import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function UnsubscribePage() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [status, setStatus] = useState({ loading: true, ok: false, msg: "" });

    useEffect(() => {
        if (!token) {
            setStatus({ loading: false, ok: false, msg: "This unsubscribe link is missing its token." });
            return;
        }
        api.get("/unsubscribe/one-click", { params: { token } })
            .then((r) => {
                if (r.data.success) setStatus({ loading: false, ok: true, msg: r.data.message });
                else setStatus({ loading: false, ok: false, msg: "We could not process this request." });
            })
            .catch((err) => setStatus({ loading: false, ok: false, msg: formatApiError(err.response?.data?.detail) }));
    }, [token]);

    return (
        <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="unsubscribe-page">
            {status.loading ? (
                <p className="font-mono text-sm text-muted-foreground animate-pulse">Processing your request…</p>
            ) : status.ok ? (
                <div className="border-2 border-pos p-10" data-testid="unsubscribe-page-success">
                    <CheckCircle2 className="text-pos mx-auto" size={44} />
                    <h1 className="font-serif text-3xl font-black mt-4">You're unsubscribed</h1>
                    <p className="mt-3 text-sm text-muted-foreground">{status.msg}</p>
                </div>
            ) : (
                <div className="border-2 border-neg p-10" data-testid="unsubscribe-page-error">
                    <AlertCircle className="text-neg mx-auto" size={44} />
                    <h1 className="font-serif text-3xl font-black mt-4">Something went wrong</h1>
                    <p className="mt-3 text-sm text-muted-foreground">{status.msg}</p>
                </div>
            )}
            <Link to="/" className="mt-8 inline-block font-mono text-xs uppercase tracking-wider text-accent">← Back home</Link>
        </div>
    );
}
